var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#71E3E2",
    d: "M71 72.364V81h-5v-8.636h-4L68.364 66l6.364 6.364H71zM86 72.364V81h-5v-8.636h-4L83.364 66l6.364 6.364H86zM62 85h28v5H62z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 78,
    x: 11,
    y: 22,
    stroke: "#71E3E2",
    strokeWidth: 5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#71E3E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M99 23L86.839 12.134A4 4 0 0 0 84.049 11H25.95a4 4 0 0 0-2.79 1.134L12 23"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 10,
    x: 42,
    y: 35,
    stroke: "#71E3E2",
    strokeWidth: 5,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#71E3E2",
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M56 11v11"
  }))));
}

export default SvgLogistics;